<template>
  <div class="container">

    <div class="loading" v-if="isDetail">
      <van-loading size="40px" type="spinner" color="#39CCCD" vertical>
        <div class="loading-text">
          <div>页面正在加载</div>
          <div>请稍候</div>
        </div>
      </van-loading>
    </div>
    <div class="content" v-html="detail.detail" v-show="!isDetail" @click="handleEnroll">
    </div>

    <div class="footer-fit" v-if="detail.id && status !== 1 && !isDetail">
      <div class="bottom">
        <div class="left">限时仅需：￥<span class="left-qian">{{ detail.price }}</span></div>
        <div class="right">
          <img :src="finger" class="finger" />
          <div class="btn" @click.stop="handleEnroll">
            <!-- <div class="grab">抓紧抢购</div> -->
            <div class="enroll">马上报名</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-fit" v-if="detail.id && status === 1 && !isDetail">
      <div class="bottom">
        <div class="left" style="margin-left:20px">已购买</div>
        <div class="right">
          <img :src="finger" class="finger" />
          <div class="btn" @click="goPickActivity">
            <div class="enroll">马上学习</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹幕 -->
    <!-- <div class="danmu" :class="isDanmu ? 'fade-out' : 'fade-in'" v-if="!isDetail">
      <img :src="danmus.img" style="width: 20px;height: 20px;border-radius: 50px;" />
      <div style="padding: 0 10px;">{{ danmus.name }}</div>
      <div>{{ danmus.time }}</div>
      <div>报名了课程</div>
    </div> -->

    <div v-if="show">
      <div class="popup_mengceng" @click="show = false"></div>

      <div class="popup-content" @click="show = true">
        <div class="top">
          <div class="title">
            <div><img :src="arrow" class="arrow" /></div>
            <div>您的手机号（确认购买的<span>唯一凭证</span>）</div>
          </div>

          <div><input clearable v-model="form.phone" class="phone" placeholder="请输入手机号" type="tel" maxlength="11"
              :rules="rules" @focus="onFocus"></div>
          <div style="position: relative;">
            <input clearable v-model="form.sms" type="tel" class="sms" placeholder="请输入验证码" maxlength="6" :rules="rules"
              @focus="onFocus">
            <div slot="button" class="code-text" @click="getCode">{{ msg }}</div>
          </div>
        </div>

        <div class="bottom">
          <div class="left">
            <span class="unit">¥</span><span class="price">{{ detail.price }}</span>
          </div>
          <div class="right" @click="pay">
            马上支付
          </div>
        </div>
      </div>
    </div>

    <div v-if="visible">
      <div class="popup_mengceng"></div>

      <div class="popup-result">
        <div class="title">请确认支付是否完成</div>
        <div class="repay" @click="createPay(true)">支付遇到问题，重新支付</div>
        <div class="done" @click="createPay(true)">支付完成</div>
      </div>
    </div>

    <!-- 登录 -->
    <!-- <van-popup v-model="show" position="bottom" round>
      <div class="popup-content">
        <div class="top">

          <div class="title">
            <div><img :src="arrow" class="arrow" /></div>
            <div>您的手机号（确认购买的<span>唯一凭证</span>）</div>
          </div>

          <van-field clearable v-model="form.phone" class="phone" placeholder="请输入手机号" maxlength="11" :rules="rules"
            @focus="onFocus" />
          <van-field v-model="form.sms" class="sms" center clearable maxlength="6" type="number" placeholder="请输入验证码"
            @focus="onFocus">
            <div slot="button" class="code-text" @click="getCode">{{ msg }}</div>
          </van-field>
        </div>

        <div class="bottom">
          <div class="left">
            <span class="unit">¥</span><span class="price">{{ detail.price }}</span>
          </div>
          <div class="right" @click="pay">
            马上支付
          </div>
        </div>
      </div>
    </van-popup> -->

    <!-- <van-popup v-model="visible" round :close-on-click-overlay="false">
      <div class="popup-result">
        <div class="title">请确认支付是否完成</div>
        <div class="repay" @click="createPay(true)">支付遇到问题，重新支付</div>
        <div class="done" @click="createPay(true)">支付完成</div>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import { checkStr } from '@/utils/validate'
import dayjs from 'dayjs';
import { get } from 'lodash';
import { Toast } from 'vant';
export default {
  name: 'LoginIndex',
  components: {},
  props: {},
  data() {
    return {
      bg: require('@/assets/bg.jpg'),
      finger: require('@/assets/finger.png'),
      arrow: require('@/assets/arrow1.png'),
      form: {
        phone: '',
        sms: ''
      },
      isDetail: true,
      detail: {
        price: 0,
        detail: ''
      },
      rules: [
        {
          required: true,
          message: '请输入手机号'
        },
        {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号'
        }
      ],
      msg: '发送验证码',
      token: '',
      show: false,
      bdVid: '', // 百度标识
      clickid: '', // 抖音标识
      isSend: false,
      visible: false,
      status: '',
      timerTask: null,
      isJump: false,
      phoneCount: '',
      timeCount: '',
      danmuTimer: null,
      danmus: {
        img: require('@/assets/avatar2.jpg'),
        name: '陈*',
        time: '5秒前'
      },
      isDanmu: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.bdVid = this.$route.query.bd_vid || ''
    this.clickid = this.$route.query.clickid || ''
    this.isJump = this.$route.query.isJump || false
    this.keywordid = this.$route.query.a_keywordid
    if (this.$route.query && this.$route.query.channel_id) {
      this.token = localStorage.getItem('token')
      this.id = this.$route.query.channel_id

      this.getDetail()
      // setInterval(() => {
      //   this.getPhone()
      // }, 5000);
      this.token && this.getOrderDetail()
      if (this.isJump) {
        this.startTask()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log('所有组件加载完成');
    });
    // this.getPhone()
    // this.getTime()
    // this.danmuTime()
    // setInterval(() => {
    //   this.getPhone()
    //   this.getTime()
    //   this.danmuTime()
    // }, 5000);
  },
  destroyed() {
    this.clearTask()
  },
  methods: {
    // getPhone() {
    //   let prefixes = ['130', '131', '132', '133', '134', '135', '136', '137', '138', '139', '147', '150', '151', '152', '153', '155', '156', '157', '158', '159', '166', '170', '171', '172', '173', '175', '176', '177', '178', '180', '181', '182', '183', '184', '185', '186', '187', '188', '189', '198', '199'];
    //   let prefix = prefixes[Math.floor(Math.random() * prefixes.length)];
    //   let number = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;
    //   var phone = prefix + number;
    //   var reg = /(\d{3})\d{4}(\d{4})/
    //   this.phoneCount = phone.replace(reg, "$1****$2")
    //   console.log(this.phoneCount)
    // },
    getTime() {
      this.timeCount = (Math.floor(Math.random() * 5) + 1) + '分钟前';
      console.log(this.timeCount)
    },

    onFocus(e) {
      console.log(e)
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });

        // e?.target?.scrollIntoView({ block: "center", behavior: "smooth" });
      }, 400);
    },

    clearTask() {
      clearInterval(this.timerTask)
      this.timerTask = null
    },
    addOrder() {
      this.$http
        .post('/app/orders/add', {
          ...this.detail,
          orderSource: 'H5',
          bdVid: this.bdVid,
          clickid: this.clickid,
          phone: this.form.phone
        })
        .then(res => {
          this.orderId = res.data
          if (this.detail.price !== 0) {
            this.createPay()
          } else {
            this.goPickActivity()
          }
        })
    },
    createPay(isJump = false) {
      this.isJump = isJump
      this.$http
        .post('/app/orders/createPay', {
          id: this.orderId,
          payType: 2,
          bdVid: this.bdVid
        })
        .then(res => {
          if (res.data) {
            this.startTask()
            window.location.href = res.data + '&redirect_url=' + encodeURIComponent(location.href + '&isJump=true&t=' + Date.now())
          }
        })
        .catch(() => {
          this.visible = false
          this.getDetail()
          this.getOrderDetail()
        })
    },
    goPickActivity() {
      this.$router.push({
        path: '/pickActivity',
        query: { id: this.id }
      })
    },
    async getDetail() {

      const res = await this.$http.get('/app/channels/getInfo', {
        id: this.id,
        bdVid: this.bdVid
      })
      console.log(res)
      if (res.code == 200) {
        this.detail = res.data;
        this.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
        document.title = res.data.title;
        setTimeout(() => {
          this.isDetail = false;
        }, 500);
      } else {
        setTimeout(() => {
          this.isDetail = false;
          Toast('网络出现问题，请刷新重试!');
        }, 3000);
      }
    },
    startTask() {
      this.clearTask()
      // 定时 查看成功的
      this.timerTask = setInterval(() => {
        this.token = localStorage.getItem('token')
        if (!this.token) {
          this.clearTask()
          return
        }
        this.$http
          .get('/app/channels/getOrder', {
            id: this.id,
            bdVid: this.bdVid
          })
          .then(res => {
            if (!res.data) {
              return
            }
            this.orderId = res.data.id
            this.status = res.data.status
            if (res.data.status === 1) {
              this.clearTask()
              this.getOrderDetail()
            }
          })
      }, 2000)
    },
    getQueryObj() {
      var query = location.search
      var queryObj = {}
      var arr = query.slice(1, query.length).split('&')
      arr.forEach(function (val) {
        var arr1 = val.split('=')
        queryObj[arr1[0]] = arr1[1]
      })

      return queryObj
    },
    getOrderDetail(isPay = false) {
      const queryObj = this.getQueryObj()
      this.$http
        .get('/app/channels/getOrder', {
          id: this.id,
          bdVid: this.bdVid
        })
        .then(res => {
          if (res.code == 401) {
            localStorage.removeItem('token');
            this.token = '';
            this.show = true;
            this.$toast('登录已失效，请重新登录')
            return
          }

          if (!res.data) {
            if (isPay) {
              // 下单 
              this.addOrder()
            }
            return
          }
          this.orderId = res.data.id
          this.status = res.data.status

          // 状态(-1已取消0待付款1已付款)
          if (res.data.status === 1) {
            this.clearTask()
            this.getAgainCourse()

            if (this.isJump || queryObj['isJump']) {
              setTimeout(() => {
                this.goPickActivity()
              }, 1500)
            }
            if (isPay) {
              setTimeout(() => {
                this.goPickActivity()
              }, 500)
            }
          }
          // 状态(-1已取消0待付款1已付款)
          if (res.data.status === 0) {
            if (isPay) {
              this.createPay()
            } else {
              // if (this.isJump || queryObj['isJump']) return

              this.visible = true
            }
          }
        })
    },
        
		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
			})
		},

    // 报名
    handleEnroll() {
      var that = this;
      if (!this.token) {
        that.show = true
      } else {
        // 发起支付
        that.getOrderDetail(true)
      }
    },
    async getCode() {
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!checkStr(this.form.phone, 'mobile')) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (this.isSend) return
      this.$http
        .post('/u/ali/sms', {
          phone: this.form.phone
        })
        .then(res => {
          this.$toast('验证码已发送')
          let count = 60
          this.isSend = true
          this.msg = count + 's'
          this.timer = setInterval(() => {
            if (count === 1) {
              this.isSend = false
              this.msg = '发送验证码'

              clearInterval(this.timer)
              return
            }
            count--
            this.msg = count + 's'
          }, 1000)
        })
    },
    pay() {
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!checkStr(this.form.phone, 'mobile')) {
        this.$toast('请输入正确手机号')
        return
      }
      if (!this.form.sms) {
        this.$toast('请输入验证码')
        return
      }
      this.$http
        .post('/u/app/login/h5SmsLogin', {
          phone: this.form.phone,
          smsCode: this.form.sms,
          bdVid: this.bdVid,
          clickid: this.clickid,
          channelId: this.id,
          keywordid: this.keywordid
        })
        .then(res => {
          this.show = false
          res.data && localStorage.setItem('token', res.data)
          // 发起支付
          this.getOrderDetail(true)
        })
    },


    getPhone() {
      this.isDanmu = true;
      setTimeout(() => {
        this.isDanmu = false;
        var num = Math.floor(Math.random() * 17);
        var list = [{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845065000751828992.jpg", name: "小笑玉" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059170669268992.jpg", name: "李冬丽" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059032240459776.jpg", name: "时光静好" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845057205503627264.jpg", name: "年年有余" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045951246471168.jpg", name: "一如既往" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045037685116928.jpg", name: "难得糊涂" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845044890985140224.jpg", name: "刘笑敏" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845010975356456960.jpg", name: "晨光曦影" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845002111324098560.jpg", name: "春暖花开" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845000414124150784.jpg", name: "风雨过林" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984893706178560.jpg", name: "谢长征" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984502872543232.jpg", name: "淡然接受" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844311874545487872.jpg", name: "旅途的人" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844288726492090368.jpg", name: "知足常乐" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844280029464334336.jpg", name: "谓我" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844238354637492224.png", name: "陈笑笑" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233814890614784.jpg", name: "丽笑丽" },
        { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233663568515072.jpg", name: "凌智科练" }]
        this.danmus.img = list[num].avatar;
        this.danmus.name = list[num].name;
        this.danmus.name = this.danmus.name.charAt(0) + '*'.repeat(this.danmus.name.length - 1) + this.danmus.name.charAt(this.danmus.name.length - 1);
        this.danmus.time = (Math.floor(Math.random() * 60) + 1) + '秒前';
      }, 1000)
    },

    danmuTime() {
      var that = this;

      //获取dom节点
      var scrollTip = document.querySelector('.danmu');
      //页面载入时，给他执行一次
      scrollTip.classList.add('fade-in');
      console.log('进入开始')

      //监听进入动画是否结束
      scrollTip.addEventListener('animationend', function () {
        //进入动画结束，移除进入动画的样式类
        scrollTip.classList.remove('fade-in')
        console.log('进入结束')

        scrollTip.removeEventListener('animationend', () => {
          console.log('移除监听')
        })

        that.danmuTimer = setTimeout(() => {
          //滑出动画加入
          scrollTip.classList.add('fade-out');
          console.log('滑出开始')

          //监听滑出动画是否结束
          scrollTip.addEventListener('animationend', function () {
            //滑出动画结束，移除滑出动画的样式类
            scrollTip.classList.remove('fade-out')
            console.log('滑出结束')
            scrollTip.removeEventListener('animationend', () => {
              console.log('移除监听')
            })

            clearTimeout(that.danmuTimer)
            that.danmuTimer = null;
            return
          })
        }, 3000);
      })
    }

  }
}
</script>

<style scoped lang="less">
.popup-result {
  top: 40vh;
  left: 0;
  right: 0;
  width: 90%;
  position: fixed;
  margin: 0 auto;
  z-index: 2002 !important;
  border-radius: 40px;
}

.popup_mengceng {
  z-index: 2001;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .7);
}

.popup-content {
  bottom: 0;
  left: 0;
  width: 100%;
  position: fixed;
  max-height: 100%;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 50px 50px 0 0;
  z-index: 2002 !important;
}

@keyframes van-fade-out {
  0% {
    opacity: 1
  }

  to {
    opacity: 0
  }
}

.content img {
  pointer-events: none;
  cursor: default;
}

.loading {
  margin: 40vh auto;
  text-align: center;

  .loading-text {
    color: #39CCCD;
    font-weight: bold;
  }
}

.container {
  color: #333;
  font-size: 28px;
  // height: 100vh !important;
  height: 100%;
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
    position: relative;
    // padding-bottom: 140px;
    // height: 100vh !important; 
    overflow-y: auto;

    ::v-deep img {
      display: block;
      width: 100% !important;
    }
  }
}

.header-bg {
  width: 100vw;
}

.footer-fit {
  flex-shrink: 0;
  // position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 2;
  // background-color: rgb(255, 250, 240);
  background-color: #f34b11;

  .bottom {
    padding: 20px 30px 20px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .left {
    // color: rgb(255, 36, 0);
    color: #fff;
    font-size: 42px;
    line-height: 40px;
    font-weight: 600;

    .left-qian {
      font-size: 45px;
      font-family: sans-serif;
    }
  }

  .right {
    position: relative;

    .finger {
      width: 100px;
      height: 100px;
      position: absolute;

      left: -60px;
      top: 50%;
      margin-top: -50px;

      z-index: 1;
      -webkit-animation: fadefinger 0.4s ease infinite alternate;
      animation: fadefinger 0.4s ease infinite alternate;
    }

    @keyframes identifier {
      0% {
        transform: scale(.95);
      }

      50% {
        transform: scale(1.02);
      }

      100% {
        transform: scale(.95);
      }
    }

    .btn {
      background-color: #fff;
      color: rgb(255, 255, 255);
      width: 300px;
      height: 100px;
      line-height: 100px;
      border-radius: 50px;
      text-align: center;
      font-size: 44px;
      // animation: identifier .7s linear infinite;

      .grab {
        font-size: 22px;
        line-height: 22px;
        margin-bottom: 10px;
        padding-top: 15px;
      }

      .enroll {
        // line-height: 44px;
        line-height: 100px;
        font-weight: bold;
        color: #f34b11;
      }
    }
  }
}

@keyframes fadefinger {
  0% {
    transform: translateX(35px);
    -webkit-transform: translateX(35px);
  }

  100% {
    transform: translateX(0);
    -webkit-transform: translateX(0);
  }
}

@keyframes updown {
  0% {
    transform: translateY(8px);
    -webkit-transform: translateY(8px);
  }

  100% {
    transform: translateY(-8px);
    -webkit-transform: translateY(-8px);
  }
}

.popup-result {
  width: 70vw;
  background: #fff;
  color: #333;
  padding: 40px 30px;

  .title {
    text-align: center;
    font-size: 32px;
    font-weight: 700;
  }

  .repay {
    width: 100%;
    line-height: 1rem;
    background: #eee;
    border-radius: 40px;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    margin-top: 30px;
  }

  .done {
    width: 100%;
    line-height: 1rem;
    background: #ff6d00;
    border-radius: 40px;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    margin-top: 30px;
    color: #fff;
  }
}

.popup-content {
  width: 100%;
  background: #fff;
  color: #333;

  .top {
    padding: 40px 30px 100px 30px;
  }

  .title {
    font-size: 34px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      color: #ff5233;
      font-weight: 700;
    }

    .arrow {
      width: 60px;
      height: 60px;
      animation: updown 0.4s ease infinite alternate;
    }
  }

  .phone {
    // position: relative;
    // width: 690px;
    width: 92%;
    background: #f5f5f5;
    border-radius: 20px;
    // padding: 27px;
    margin-top: 20px;

    padding: 27px;
    border: none !important;
  }

  .sms {
    // position: relative;
    margin-top: 20px;
    width: 690px;
    background: #f5f5f5;
    border-radius: 20px;

    width: 92%;
    padding: 27px;
    border: none !important;

  }

  .code-text {
    color: rgb(255, 36, 0);

    position: absolute;
    top: 24px;
    right: 27px;
    bottom: 0;
    display: flex;
    align-items: center;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgb(255, 36, 0);
    padding: 15px 30px;

    .left {
      color: #fff;
      font-size: 80px;
      line-height: 80px;

      display: flex;
      -webkit-box-align: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-shrink: 0;
      position: relative;

      .unit {
        font-size: 30px;
        line-height: 30px;
        position: absolute;
        left: 0;
        top: 25px;
        display: inline-block;
      }

      .price {
        padding: 18px;
        font-weight: 700;
      }

      .d-price {
        background: #fff532;
        border-radius: 10px;
        font-weight: 400;
        color: #ff5233;
        font-size: 30px;
        padding: 0 10px;
        line-height: 40px;
      }
    }

    .right {
      color: rgb(240, 53, 0);
      background: rgb(255, 255, 255);
      width: 300px;
      height: 100px;
      line-height: 100px;
      border-radius: 50px;
      text-align: center;
      font-weight: 700;
      font-size: 50px;
    }
  }
}

.van-popup {
  background: #f4f4f4;
}

.active {
  border: 4px solid #ff6d00 !important;
}


.danmu {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 15vh;
  right: 20px;
  padding: 10px 20px;
  background: #00000075;
  color: #fff;
  font-size: 28px;
  border-radius: 50px;
  width: 60%;
}

.fade-in {
  animation: slide-up-fade-in 1s forwards;
}

@keyframes slide-up-fade-in {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.fade-out {
  animation: slide-up-fade-out 1s forwards;
}

@keyframes slide-up-fade-out {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-30px);
    opacity: 0;
  }
}
</style>
